const ProfileExperience = {
  components: {
    'dmtk-textarea': FormTextArea,
  },
  mixins: [ProfileValidation],
  data() {
    return {
      limit: 10,
      sector: null, //'asistentes-personales',
      activities: [],
      labels: {
        required: 'Debes rellenar este campo para poder publicar tu perfil',
      },
    };
  },
  computed: {
    ...Vuex.mapState(['signup', 'profile', 'sectors', 'studies', 'languages']),
    activitiesLimitReached() {
      return this.profile.activities.length >= this.limit;
    },
  },
  mounted() {
    if (!this.signup) {
      this.$v.profile.$touch();
    }
  },
  methods: {
    toggleLanguage(lang) {
      const idx = this.profile.languages.indexOf(lang._id);
      //console.log('toggleLanguage', idx, lang._id, this.profile.languages);
      if (idx < 0) {
        this.profile.languages.push(lang._id);
      } else {
        if (lang._id !== 'spanish') {
          this.profile.languages.splice(idx, 1);
        }
      }
      this.$v.profile.languages.$touch();
    },
    updateSector() {
      axios
        .get(`/terminos/${this.sector}/`)
        .then((data) => (this.activities = data.data.children));
    },
    toggleActivity(activity) {
      //miramos si está en el índice
      const idx = this.profile.activities
        .map((a) => a._id)
        .indexOf(activity._id);
      //console.log('toggleActivity', activity.name, this.profile.activities);
      //añadimos o borramos
      if (idx < 0) {
        this.profile.activities.push(activity);
      } else {
        this.profile.activities.splice(idx, 1);
      }
      //y actualizamos la store
      this.$set(this.profile, 'activities', this.profile.activities);
      this.$v.profile.activities.$touch();
    },
    isActivityChecked(activity) {
      return (
        this.profile.activities.map((a) => a._id).indexOf(activity._id) >= 0
      );
    },
    show_warning(field) {
      return this.$v.profile[field].$dirty && this.$v.profile[field].$invalid;
    },
  },
  template: `
      <div>
        
      <div class="uk-grid">
        <div class="uk-width-1-1">
          <h3 v-if="profile.type === 'P'">Experiencia y habilidades</h3>
          <h3 v-if="profile.type === 'E'">Especialidades</h3>
          <p v-if="profile.type ==='P'">
            Aprovecha este campo para dar más información sobre tus especialidades,
            trayectoria o proyectos especiales que hayas realizado.
          </p>
          <p v-else>
            Aprovecha este campo para dar más información sobre tus especialidades
            y proyectos que tu empresa haya realizado.
          </p>
          <dmtk-textarea
            rows="10"
            limit="600"
            :value="profile.experience"
            @input="profile.experience = $event;"
            :placeholder="profile.type === 'P' ? 'Escribe aquí tu experiencia y habilidades laborales' : 'Describe aquí tus especialidades y proyectos'"
          ></dmtk-textarea>
          <span class="uk-text-warning" v-if="!this.signup && $v.profile.experience.$invalid">
              Rellena tu experiencia para mejorar tu perfil
            </span>
        </div>
      </div>

      <div class="uk-grid">
          <div class="uk-width-1-1 uk-margin-bottom">
            <h3>Actividades</h3>
            <p>
              Elige las actividades en las que quieres ofrecer tus servicios. Tienes que elegir al menos una, pero te
              puedes apuntar a un máximo de 10.
              <span v-if="profile.type === 'P'">
                Asegúrate de elegir aquellas que tu formación y experiencia te permite realizar con eficacia.
              </span>
            </p>
            <div class="uk-alert uk-alert-danger" v-if="show_warning('activities')">
              {{ this.labels.required }}
            </div>
          </div>
          <div class="uk-width-1-2@m">
            <label>Sectores</label>
            <select
              class="uk-select"
              v-model="sector"
              @change="updateSector(sector)"
            >
              <option disabled :value="null">Selecciona un sector</option>
              <option v-for="sector in sectors" :value="sector._id">{{ sector.name }}</option>
            </select>
            <ul class="uk-list">
              <li v-for="(activity, idx) in activities">
                <label>
                  <input
                    type="checkbox"
                    class="uk-checkbox"
                    :value="{...activity}"
                    @click="toggleActivity(activity)"
                    :checked="isActivityChecked(activity)"
                    :disabled="activitiesLimitReached && !isActivityChecked(activity)"
                  >
                  {{ activity.name }}
                </label>
              </li>
            </ul>
          </div>
          <div class="uk-width-1-2@m">
            <div v-if="profile.activities.length > 0" class="uk-margin-medium-top">
              <h4>Estás apuntado a</h4>
              <ul class="uk-list">
                <li v-for="(activity, idx) in profile.activities">
                  <label>
                    {{ activity.title }}
                    <span @click="toggleActivity(activity)" class="x-remove --black"></span>
                  </label>
                </li>
              </ul>
              <small v-if="this.activities.length < limit">
                Puedes apuntarte a {{limit - profile.activities.length}} actividades más.
              </small>
              <small v-if="this.activities.length == limit">
                No puedes apuntarte a más actividades
              </small>
            </div>
          </div>
        </div>
        
      <div class="uk-grid" v-if="profile.type == 'P'">
        <div class="uk-width-1-2@m uk-margin-top">
          <h3>Formación</h3>
          <select 
	          class="uk-select" 
	          v-model="profile.studies"
	          @change="$v.profile.studies.$touch()"
          >
            <option disabled>Selecciona tu formación</option>
            <option
                v-for="study in studies"
                :value="study._id"
            >{{ study.name }}
            </option>
          </select>
          <span class="uk-text-warning" v-if="!this.signup && show_warning('studies')">
            Rellena tu formación para mejorar tu perfil
          </span>
        </div>
        <div class="uk-width-1-2@m uk-margin-top">
          <h3>Estudios complementarios</h3>
          <dmtk-textarea
              rows="8"
              :value="profile.education"
              @input="profile.education = $event"
              placeholder="Escribe aquí información acerca de tu educación"
          ></dmtk-textarea>
          <span class="uk-text-warning" v-if="!this.signup && !$v.profile.education.required">
              Rellena tu educación para mejorar tu perfil
            </span>
        </div>
      </div>

      <div class="uk-grid">
          <div class="uk-width-1-1">
            <h3>Idiomas</h3>
            <p>
              Si utilizas diferentes idiomas con tus clientes, puedes indicarlos aquí:
            </p>
            <div class="uk-margin-top uk-grid uk-grid-small" uk-margin>
              <label v-for="lang in languages">
                <button
                  @click="toggleLanguage(lang)"
                  class="uk-button uk-chip uk-display-block"
                  :class="{'-selected': profile.languages.indexOf(lang._id) !== -1}"
                >{{ lang.name }}
                </button>
              </label>
            </div>
            <p class="uk-text-small">
              Si hablas algún otro idioma que no esté aquí incluido, indícalo en la sección de 
              {{ profile.type === 'P' ? 'experiencia' : 'especialidades' }}.
            </p>
            <div class="uk-text-warning uk-margin-top" v-if="show_warning('languages')">
              {{ this.labels.required }}
            </div>
          </div>
        </div>

      <div class="uk-text-right uk-margin-large-top uk-margin-large-bottom">
        <button v-if="!signup" @click="$parent.$emit('profile.save');" class="uk-button uk-button-dmtk">Guardar</button>
        <router-link v-if="signup" to="/disponibilidad" class="uk-button uk-button-primary uk-button-bold">
          Siguiente
        </router-link>
      </div>

      </div>
	`,
};
